<template>
  <v-card
    class="fill-height d-flex flex-column"
    :href="pdfLink"
    elevation="5"
  >
    <v-img
      :src="pdfThumb"
      :aspect-ratio="3/4"
      contain
      @error="previewError"
    />
    <v-divider />
    <v-card-title><v-chip v-if="chip">{{ chip }}</v-chip> {{ label }}</v-card-title>
    <v-card-actions>
      <v-btn :color="mainColor" block :href="pdf" :dark="dark">öffnen</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

  import { assets_url } from '@/assets.js'

  export default {
    name: 'AmtstafelCard',
    props: ["label", "pdf", "mainColor", "chip", "dark", "fallback"],
    components: {
    },
    mounted(){
    },
    methods: {
      previewError(){
        //console.log("error", this.pdfThumb, this.pdf)
        this.error = true
      }
    },
    computed: {
      pdfThumb(){
        if (!this.error){
          const width = 650
          const height = Math.floor(width/3*4)
          const url = assets_url(this.pdf, `fixed=${width}x${height}`, "/1")
          return url
        } else if (this.fallback){
          return this.fallback
        } else {
          return null
        }
      },
      pdfLink(){
        if (this.error){
          return this.pdf
        } else {
          return assets_url(this.pdf)
        }
      }
    },
    data: () => ({
      error: false
    }),
  }
</script>
